window._lgconf = {
    dealerId: "8b7c7877-b313-497a-a903-98590beaa5db",
    i18n: {
        widgetTitle: 'Vad är din bil värd?',
        buttonText: 'Värdera din bil'
    }
};

(function(d) {
    var s = d.createElement("script");
    s.type = "text/javascript";
    s.src = "https://lg.indicata.com/widget/v1/widget.js";
    d.getElementsByTagName("head")[0]
        .appendChild(s);
})(document);